import React from "react";
import { CirclePlus } from "lucide-react";
import { Link } from "react-router-dom";
import AuthorsListView from "./components/AuthorsListView";

export default function AuthorsPage() {
  return (
    <main className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="fw-bold h4">Authors</h1>
        <Link to="/admin/authors/form">
          <button className="btn btn-primary d-flex align-items-center gap-2 shadow">
            <CirclePlus />
            Add Author
          </button>
        </Link>
      </div>
      <AuthorsListView />
    </main>
  );
}
